import PDF_LAYOUTS from "../pageLayouts.json";

/**
 * Номер физической страницы (стороны), как видит пользователь.
 * Согласовано с getSpreadLabel в PhotoBookEditor.jsx:
 *   i=0 — обложка, i=1 — форзац (страница 1),
 *   i>=2 — левая = 2*i-2, правая = 2*i-1.
 */
function physicalPageNumber(i, side) {
  if (i === 1) return 1;                // форзац — только правая = страница 1
  if (i <= 0) return null;              // обложка
  return side === "left" ? (2 * i - 2) : (2 * i - 1);
}

// Сколько слотов у макета (по id). Должно совпадать с сервером
// main/models.py::LAYOUT_SLOT_COUNT.
const LAYOUT_SLOT_COUNT = {
  "empty": 0,
  "single": 1,
  "stack-2": 2,
  "grid-4": 4,
  "big-left": 3,
  "stripe-3": 3,
  "panorama-top": 3,
};

for (const [id, count] of Object.entries({ ...LAYOUT_SLOT_COUNT })) {
  if (id !== "empty") LAYOUT_SLOT_COUNT[id + "-framed"] = count;
}
for (const [id, spec] of Object.entries(PDF_LAYOUTS)) {
  LAYOUT_SLOT_COUNT[id] = spec.cells.length;
}

export function validateBook(pages) {
  const notUploaded = []; // фото выбрано, но не догрузилось на сервер (это ОШИБКА)
  const emptyPages = [];  // сторона с непустым макетом, где заполнены НЕ все слоты
  const totalPages = pages.length;

  pages.forEach((pg, i) => {
    if (i === 0) return;      // обложка

    ["left", "right"].forEach((side) => {
      // Непечатаемые стороны не проверяем (совпадает с сервером):
      //  • левая первого контентного разворота (форзац) — i===1 уже пропущен;
      //  • правая последнего разворота — печатается пустой.
      if (i === 1 && side === "left") return;
      if (side === "right" && i === totalPages - 1) return;

      const layoutId = side === "left" ? pg.leftLayoutId : pg.rightLayoutId;
      if (!layoutId || layoutId === "empty") return; // пустой макет — фото не нужно

      const expected = LAYOUT_SLOT_COUNT[layoutId] ?? 1;
      const slots = pg[side] ?? {};

      // считаем занятые слоты и ловим «не догрузилось»
      let filled = 0;
      for (let idx = 0; idx < expected; idx++) {
        const p = slots[idx];
        if (p) {
          filled++;
          if (p.url && !p.serverUrl) {
            const pageNum = physicalPageNumber(i, side);
            notUploaded.push({
              index: i, side, pageNumber: pageNum,
              label: `страница ${pageNum} (${side === "left" ? "левая" : "правая"}) — фото не загрузилось, добавьте заново`,
            });
          }
        }
      }

      if (filled < expected) {
        const pageNum = physicalPageNumber(i, side);
        emptyPages.push({
          index: i, side, pageNumber: pageNum,
          filled, expected,
          label: `страница ${pageNum} (${side === "left" ? "левая" : "правая"})` +
                 (expected > 1 ? ` — заполнено ${filled} из ${expected}` : " — пустая"),
        });
      }
    });
  });

  return {
    // isValid оставляем строгим ТОЛЬКО по «не догрузилось» — это настоящая ошибка,
    // которую нельзя пропускать. Пустые страницы обрабатываем отдельно (мягко).
    isValid: notUploaded.length === 0,
    notUploaded,
    emptyPages,
  };
}